import { MoreHorizontalSolid } from '@simplywallst/ui-core/icons';
import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';
import type { TypeformId } from '@/hooks/useTypeformDrawer';

import { ButtonWithDropdown } from '@simplywallst/ui-core';

interface Props {
  formId: TypeformId;
  companyName?: string;
}

export const Feedback = ({ formId, companyName }: Props) => {
  const makeTypeformPopup = useTypeformDrawer(
    formId,
    companyName ? { company: companyName } : undefined
  );

  return (
    <ButtonWithDropdown
      name="more"
      styleType="passive"
      options={[{ label: 'Feedback', value: 'FEEDBACK' }]}
      onSelect={makeTypeformPopup}
    >
      <MoreHorizontalSolid />
    </ButtonWithDropdown>
  );
};
